// /frontend/src/components/StatusDropdown.js  (v2.0 – modernized UI)
import React, { useState, useRef, useEffect } from 'react';

const STATUS_OPTIONS = [
  { value: 'scheduled', label: 'Scheduled',    icon: 'fa fa-clock',        color: '#2563eb', bg: '#eff6ff' },
  { value: 'posted',    label: 'Completed',     icon: 'fa fa-check-circle', color: '#16a34a', bg: '#dcfce7' },
  { value: 'all',       label: 'All Statuses',  icon: 'fa fa-globe',        color: '#6b7280', bg: '#f3f4f6' },
];

function StatusDropdown({ selectedStatus, onChange }) {
  const [open, setOpen]       = useState(false);
  const [hovered, setHovered] = useState(null);
  const dropdownRef           = useRef(null);

  useEffect(() => {
    function handleClickOutside(e) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) setOpen(false);
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const selected = STATUS_OPTIONS.find(o => o.value === selectedStatus) || STATUS_OPTIONS[0];

  return (
    <div ref={dropdownRef} style={{ position: 'relative', display: 'inline-block' }}>

      {/* Trigger button */}
      <button
        type='button'
        onClick={() => setOpen(!open)}
        style={{
          display        : 'flex',
          alignItems     : 'center',
          gap            : 7,
          padding        : '7px 12px',
          borderRadius   : 8,
          border         : `1.5px solid ${open ? '#2563eb' : '#e5e7eb'}`,
          background     : open ? '#eff6ff' : '#ffffff',
          cursor         : 'pointer',
          fontSize       : 13,
          fontWeight     : 600,
          color          : open ? '#2563eb' : '#374151',
          transition     : 'all 0.15s',
          whiteSpace     : 'nowrap',
          boxShadow      : '0 1px 2px rgba(0,0,0,0.05)',
        }}
      >
        <div style={{
          width        : 20,
          height       : 20,
          borderRadius : '50%',
          background   : selected.bg,
          display      : 'flex',
          alignItems   : 'center',
          justifyContent: 'center',
          flexShrink   : 0,
        }}>
          <i className={selected.icon} style={{ fontSize: 9, color: selected.color }} />
        </div>
        {selected.label}
        <i
          className={`fas fa-chevron-${open ? 'up' : 'down'}`}
          style={{ fontSize: 10, color: '#9ca3af', marginLeft: 2 }}
        />
      </button>

      {/* Dropdown */}
      {open && (
        <div style={{
          position    : 'absolute',
          top         : 'calc(100% + 6px)',
          left        : 0,
          background  : '#ffffff',
          border      : '1px solid #e5e7eb',
          borderRadius: 10,
          minWidth    : 180,
          zIndex      : 1000,
          padding     : 4,
          boxShadow   : '0 8px 24px rgba(0,0,0,0.1)',
        }}>
          {STATUS_OPTIONS.map(opt => (
            <div
              key={opt.value}
              onClick={() => { onChange(opt.value); setOpen(false); }}
              onMouseEnter={() => setHovered(opt.value)}
              onMouseLeave={() => setHovered(null)}
              style={{
                display      : 'flex',
                alignItems   : 'center',
                gap          : 10,
                padding      : '8px 12px',
                borderRadius : 7,
                cursor       : 'pointer',
                background   : hovered === opt.value
                  ? '#f8fafc'
                  : selected.value === opt.value
                    ? opt.bg
                    : 'transparent',
                transition   : 'background 0.1s',
              }}
            >
              <div style={{
                width        : 26,
                height       : 26,
                borderRadius : '50%',
                background   : opt.bg,
                display      : 'flex',
                alignItems   : 'center',
                justifyContent: 'center',
                flexShrink   : 0,
              }}>
                <i className={opt.icon} style={{ fontSize: 11, color: opt.color }} />
              </div>
              <span style={{
                fontSize  : 13,
                fontWeight: selected.value === opt.value ? 700 : 500,
                color     : selected.value === opt.value ? opt.color : '#374151',
              }}>
                {opt.label}
              </span>
              {selected.value === opt.value && (
                <i className='fas fa-check' style={{ fontSize: 10, color: opt.color, marginLeft: 'auto' }} />
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default StatusDropdown;